import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@cnt-workspace/data-access';
import { Role } from '@curbnturf/entities';

/**
 * Replaces @curbnturf/auth's NgRx-backed AdminGuard. Awaits
 * `currentUserOnceLoaded()` (not the sync `currentUser` getter) so a signed-in
 * admin isn't bounced to login on a fresh page load before the Cognito session
 * has restored — same pattern as data-access-cnt's auth.guard/sales-access.guard.
 * The real boundary is still the server's AdminAuthGuard/ACL checks.
 *
 * Query keys are lowercase (`returnto`) because the admin app's
 * LowerCaseUrlSerializer lower-cases the whole URL on parse — a camelCase key
 * doesn't survive the redirect.
 */
export const adminGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = await auth.currentUserOnceLoaded();
  if (!user) {
    return router.createUrlTree(['/auth/login'], { queryParams: { returnto: state.url } });
  }

  return user.role === Role.admin ? true : router.createUrlTree(['/auth/login'], { queryParams: { denied: 1 } });
};
